import AbstractType from "./AbstractType";

export default class ObjectType extends AbstractType
{
    static type="object";

    test = (value) => typeof value === "object";
}